import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollWindowToTop } from "@/lib/scroll";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    scrollWindowToTop();
  }, [pathname]);

  return null;
}
